import React from "react";
import MobilePropertyDescription from "../mobile-property-description";
import { useSalesInstruction } from "../../../../hooks/react-query/properties/useSalesInstruction";

export default function AdditionalMobileInformation({ objPropertyDetails, type }: any) {

  const { data: salesInstruction } = useSalesInstruction(
    objPropertyDetails?.sfid
  );

  return (
    <>
      {salesInstruction?.Instructions__c && (
        <MobilePropertyDescription
          title={"Additional Information"}
          propertyDetails={salesInstruction?.Instructions__c}
          viewMoreWords={250}
        />
      )}
    </>
  );
}
